import _isEmpty from 'lodash/isEmpty'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { updateGroupedFilters } from 'state/global/actions'

const useInitGlobalFilter = (groupedFilters: GroupedProviderFilter): void => {
  const dispatch = useDispatch()

  useEffect(() => {
    if (!_isEmpty(groupedFilters)) {
      updateGroupedFilters(dispatch, groupedFilters)
    }
  }, [groupedFilters])
}

export default useInitGlobalFilter
